import { render, staticRenderFns } from "./DeveloperAccount.vue?vue&type=template&id=65ce38fe"
import script from "./DeveloperAccount.vue?vue&type=script&lang=js"
export * from "./DeveloperAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports